export class InvoiceList {
  invoice: string;
  status: string;
  issue: string;
  paid: string;
  total: string;
  method: string;
}
